import { useEditorStore } from '../state/editorStore';

/** Transient notification strip. Also the visible feedback for refused commands. */
export function Toast() {
  const toast = useEditorStore((s) => s.toast);
  const dismiss = useEditorStore((s) => s.dismissToast);
  if (!toast) return null;

  const tone =
    toast.kind === 'error'
      ? 'border-danger/70 text-danger'
      : toast.kind === 'warn'
        ? 'border-warn/70 text-warn'
        : 'border-line text-ink';

  return (
    <div
      key={toast.id}
      role="status"
      aria-live="polite"
      className="fixed bottom-9 left-1/2 z-50 -translate-x-1/2"
      data-testid="toast"
    >
      <button
        type="button"
        onClick={dismiss}
        className={`cursor-pointer rounded-lg border bg-surface-2 px-3 py-2 text-center shadow-2xl shadow-black/50 ${tone}`}
      >
        {toast.message}
      </button>
    </div>
  );
}
